<app-toolbar *ngIf="filter$ | async as filter">
  <app-breadcrumbs>
  </app-breadcrumbs>
  <app-page-search class="me-auto" [(searchString)]="filter.Global" (searchStringChange)="filter$.next(filter)"></app-page-search>
  <app-toolbar-list-buttons *ngIf="PRIVILEGES.EditCommonData | userHasPrivilege" (addClick)="edit(null)">
  </app-toolbar-list-buttons>
</app-toolbar>
<p-table styleClass="p-datatable-sm p-datatable-striped"
         dataKey="Id"
         sortField="Code"
         [value]="classificators$ | async"
         [paginator]="true"
         [rows]="50"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [showCurrentPageReport]="true"
         [globalFilterFields]="['Name', 'Code', 'Comment', 'FlattenedValues']"
         currentPageReportTemplate="{first} to {last} of {totalRecords}">
  <ng-template pTemplate="header">
    <ng-container *transloco="let t; read: 'ime.parameters.classificator'">
      <tr>
        <th pSortableColumn="Code">
          {{t('Code')}}
          <p-sortIcon field="Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Name">
          {{t('Name')}}
          <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th>{{t('Values')}}</th>
        <th pSortableColumn="Comment">
          {{t('Comment')}}
          <p-sortIcon field="Comment"></p-sortIcon>
        </th>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td><a href="javascript:void(0)" (click)="edit(row.Id)">{{row.Code}}</a></td>
      <td><a href="javascript:void(0)" (click)="edit(row.Id)">{{row.Name}}</a></td>
      <td>
        <ng-container *ngFor="let clv of row.ClassificatorValues">
          <a class="badge me-1 px-1 text-wrap text-break text-start text-white text-decoration-none" [ngClass]="{'bg-default': clv.IsDisabled, 'bg-primary': !clv.IsDisabled}" (click)="edit(row.Id)">
            {{clv.Value}}
          </a>
          <br/>
        </ng-container>
      </td>
      <td><a href="javascript:void(0)" (click)="edit(row.Id)">{{row.Comment}}</a></td>
    </tr>
  </ng-template>
</p-table>
